import { brpGroup } from "./clients/brpGroup";
import { demo } from "./clients/demo";
import { development } from "./clients/development";
import { magGroup } from "./clients/magGroup";
import { mivasaGroup } from "./clients/mivasaGroup";
import { tobsaGroup } from "./clients/tobsaGroup";
import { bmw } from "./clients/bmw";

const removeKeywords = [
  "www.",
  "localhost.",
  ".io",
  ".com",
  "crm.",
  "https://",
  "http://",
  "local.",
  "staging.",
  ".warbox",
  ".netlify",
  ".app",
  "citas.",
];

const host = window.location.hostname.toLowerCase();

const siteName = removeKeywords.reduce((acc, keyword) => {
  return acc.replace(keyword, "");
}, host);

const SITE_SETTINGS = {
  brp: brpGroup,
  demo,
  mag: magGroup,
  mivasa: mivasaGroup,
  tobsa: tobsaGroup,
  bmw,
  default: development,
};

export default SITE_SETTINGS[siteName]
  ? SITE_SETTINGS[siteName]
  : SITE_SETTINGS.default;
